import { Input } from 'antd';
import styled from 'styled-components';

export const SearchInputWrapper = styled(Input)`
  width: 20.438rem;
  height: 3.125rem;
  font-size: 1.5rem;
  box-shadow: inset 1px 1px 4px rgba(0, 0, 0, 0.25);
  margin-left: 1.875rem;
`;
